import { PlanType } from "@/enums";

export const getLppsaPlanClass = (planType: PlanType) => {
    switch (planType) {
        case PlanType.LppsaA:
            return 1;
        case PlanType.LppsaB:
            return 2;
        case PlanType.LppsaC:
            return 3;
        default:
            return planType;
    };
}